module.exports = __webpack_public_path__ + "img/pp_service2.ab2959b6.png";